import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ModuleId } from '@pixacare/forms';
import { complianceLogoByModuleId } from './compliance-logo-by-module-id.config';

@Component({
  selector: 'pxc-compliance-logo',
  template: `
    @if (src(); as logoSrc) {
      <img class="h-full w-auto object-cover" [src]="logoSrc" />
    }
  `,
  host: {
    class: 'pointer-events-none m-2 block',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplianceLogoComponent {
  readonly targetModuleId = input.required<ModuleId>();
  protected readonly src = computed(() => complianceLogoByModuleId[this.targetModuleId()]);
}
